"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEGAL_PERSON = exports.NATURAL_PERSON = void 0;
exports.NATURAL_PERSON = 'N';
exports.LEGAL_PERSON = 'J';
//# sourceMappingURL=customerTypes.js.map